import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';

import { ENV } from 'digital-core';

@Component({
  selector: 'gsp-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {
  title: string;
  closeBtnName = "Close";
  list: any[] = [];
  errorData: any;
  panelOpenState = false;
  errorMessage: string;

  setStep(index: number) {
    this.panelOpenState = !this.panelOpenState;
    this.cd.detectChanges();
  }

  constructor(
    public bsModalRef: BsModalRef,
    private cd: ChangeDetectorRef,
    @Inject(ENV) private environment: any
  ) {

  }

  ngOnInit() {
  }

  close() {
    this.bsModalRef.hide();
  }

  getErrorMessage() {
    if (this.errorData.hasOwnProperty("message")) {
      return this.errorData.message;
    } else {
      return this.errorData;
    }
  }
  showDetailedError() {
    return this.errorData != null && !this.environment.production;
  }
}
